export const gdpr = {
  routes: [
    {
      path: "/datasubject",
      component: () => import("../organization-datasubject-view"),
    },
  ],
};

export const workspace = {
  routes: [
    {
      path: "/workspace/library/datasubject",
      component: () => import("../workspace-library-datasubject-view"),
    },
    {
      path: "/workspace/library/datasubject-category",
      component: () => import("../workspace-library-datasubject-category-view"),
    },
  ],
};

export const management = {
  routes: [
  ],
};
